<template>
    <b-row class="p-0 p-0">
    
       
        
        <!-- begining of the question answer -->
        <b-col lg="12" class="p-0 m-0 ">
            <b-row class="p-0 m-0 ">
               
                <b-col lg="12" class="m-0 p-0 text-center">
                  
                    <div class="mx-auto my-5 p-4 p-md-5 rounded-4 text-white shadow-lg"
                        style="background: rgba(0,0,0,0.86); max-width: 980px; text-align: justify; line-height: 1.45;">

                    <!-- Header -->
                    <div class="d-flex align-items-center mb-4" style="gap: 1.2rem; line-height: 1;">
                        <!-- Big gradient icon (inline SVG inside a gradient circle) -->
                        <div class="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
                            style="width: 68px; height: 68px; background: linear-gradient(135deg,#0d6efd,#6f42c1);
                                    box-shadow: 0 8px 24px rgba(0,0,0,.35), inset 0 0 0 2px rgba(255,255,255,.15);">
                        <!-- Shield-check icon -->
                        <svg width="37" height="37" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                            <path d="M5.338 1.59a61 61 0 0 0-2.837.856A1 1 0 0 0 1 3.39V6c0 5.255 3.522 7.507 6.364 8.651a1 1 0 0 0 .272.06 1 1 0 0 0 .272-.06C10.75 13.507 14 11.255 14 6V3.39a1 1 0 0 0-.5-.864 61 61 0 0 0-2.838-.856c-.39-.12-.778-.24-1.158-.368a4 4 0 0 0-2.008 0c-.38.128-.768.248-1.158.368"/>
                            <path d="M10.97 5.97a.75.75 0 0 1 0 1.06L7.477 10.52a.75.75 0 0 1-1.06 0L5.03 9.13a.75.75 0 1 1 1.06-1.06l.887.886 3.0-3.0a.75.75 0 0 1 1.06 0"/>
                        </svg>
                        </div>

                        <div class="flex-grow-1">
                        <h2 class="fw-bold mb-1" style="letter-spacing: .2px; font-size: clamp(1.9rem, 2.2vw + 1rem, 2.6rem); line-height: 1.15;">
                            Лицензия и регулирование
                        </h2>
                        <div class="text-white-50" style="font-size: .95rem;">Digital Galaxy Ltd. · AIFC / AFSA</div>
                        </div>
                    </div>

                    <!-- Intro -->
                    <p class="mb-3" style="line-height: 1.45;">
                        <strong>Digital Galaxy Ltd.</strong> является авторизованной компанией, получившей официальную лицензию
                        на осуществление регулируемой деятельности в соответствии с Актами Международного финансового центра «Астана» (AIFC).
                    </p>
                    <p class="mb-4" style="line-height: 1.45;">
                        Регулирование деятельности осуществляется <strong>Astana Financial Services Authority (AFSA)</strong> – независимым органом финансового надзора AIFC.
                    </p>

                    <!-- License info -->
                    <div class="mb-4">
                        <div class="d-flex align-items-center mb-3" style="gap: .8rem; line-height: 1.2;">
                        <!-- small section icon -->
                        <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true" style="margin-top: -2px;">
                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4.5h12zM3.5 0A1.5 1.5 0 0 0 2 1.5V3h12V1.5A1.5 1.5 0 0 0 12.5 0h-9z"/>
                        </svg>
                        <h5 class="mb-0 text-white-50 text-uppercase fw-semibold" style="letter-spacing: .5px; font-size: 1.2rem;">
                            Информация о лицензии
                        </h5>
                        </div>

                        <ul class="list-unstyled m-0" style="line-height: 1.55; font-size: 1.05rem;">
                        <li class="mb-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" class="me-2" aria-hidden="true" style="margin-right: .75rem;">
                            <path d="M9.669.864 8 0 6.331.864l-1.2 2.4-2.664.387L1.5 5.5l-1.033 2.25L1.5 10l1.967.349 1.2 2.4L8 14l1.331-1.251 1.2-2.4L12.5 10l1.033-2.25L12.5 5.5l-1.967-.849-1.2-2.4z"/>
                            </svg>
                            <strong>Номер лицензии:</strong> AFSA-A-LA-2025-0001
                        </li>
                        <li class="mb-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" style="margin-right: .75rem;">
                            <path d="M3.5 0a.5.5 0 0 0 0 1H4v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V1h.5a.5.5 0 0 0 0-1h-9zM14 4H2a1 1 0 0 0-1 1v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1z"/>
                            </svg>
                            <strong>Дата выдачи:</strong> 9 января 2025 года
                        </li>
                        <li class="mb-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" style="margin-right: .75rem;">
                            <path d="M8.5 3a.5.5 0 0 0-1 0v5.793l-2.146 2.147a.5.5 0 0 0 .708.707l2.292-2.292V3z"/>
                            </svg>
                            <strong>Срок действия:</strong> до 8 января 2027 года
                        </li>
                        <li class="mb-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" style="margin-right: .75rem;">
                            <path d="M6.5 0a.5.5 0 0 0-.5.5V2H3a2 2 0 0 0-2 2v10h14V4a2 2 0 0 0-2-2H10V.5a.5.5 0 0 0-1 0V2H7V.5a.5.5 0 0 0-.5-.5z"/>
                            </svg>
                            <strong>Орган:</strong> Astana Financial Services Authority (AFSA)
                        </li>
                        <li class="mb-2">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" style="margin-right: .75rem;">
                            <path d="M2 2h12v12H2z"/>
                            </svg>
                            <strong>БИН:</strong> 241140900517
                        </li>
                        <li>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="#0dcaf0" style="margin-right: .75rem;">
                            <path d="M8 0a5 5 0 0 0-5 5c0 3.1 5 11 5 11s5-7.9 5-11a5 5 0 0 0-5-5z"/>
                            </svg>
                            <strong>Юрисдикция:</strong> МФЦА (AIFC), Республика Казахстан
                        </li>
                        </ul>
                    </div>

                    <!-- Activities -->
                    <div class="mb-4">
                        <div class="d-flex align-items-center mb-3" style="gap: .8rem; line-height: 1.2;">
                        <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true" style="margin-top: -2px;">
                            <path d="M0 2h6v6H0V2zm10 0h6v6h-6V2zM0 10h6v6H0v-6zm10 0h6v6h-6v-6z"/>
                        </svg>
                        <h5 class="mb-0 text-white-50 text-uppercase fw-semibold" style="letter-spacing: .5px; font-size: 1.2rem;">
                            Разрешённые виды деятельности (цифровые активы)
                        </h5>
                        </div>
                        <ol class="ps-3 mb-0" style="line-height: 1.55; font-size: 1.05rem;">
                        <li class="mb-3">
                            <strong>Arranging Custody</strong> – организация хранения цифровых активов. Digital Galaxy Ltd. может
                            заключать договоры с провайдерами цифровых кошельков и обеспечивать безопасное хранение активов.
                        </li>
                        <li class="mb-3">
                            <strong>Dealing in Investments as Agent</strong> – посредничество между клиентом и сторонними площадками
                            (включая криптобиржи) по поручениям на покупку/продажу цифровых активов.
                        </li>
                        <li>
                            <strong>Dealing in Investments as Principal</strong> – сделки от собственного имени с обеспечением ликвидности операций.
                        </li>
                        </ol>
                    </div>

                    <!-- Compliance -->
                    <div class="mb-4">
                        <div class="d-flex align-items-center mb-3" style="gap: .8rem; line-height: 1.2;">
                        <svg width="20" height="20" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true" style="margin-top: -2px;">
                            <path d="M5.5 1.5L8 0l2.5 1.5L13 3l-1 3-1 3-3 2-3-2-1-3-1-3 2.5-1.5z"/>
                        </svg>
                        <h5 class="mb-0 text-white-50 text-uppercase fw-semibold" style="letter-spacing: .5px; font-size: 1.2rem;">
                            Регулирование и надзор
                        </h5>
                        </div>
                        <ul class="mb-0" style="line-height: 1.55; font-size: 1.05rem;">
                        <li>Соблюдение стандартов <strong>AML/CFT</strong> (ПОД/ФТ).</li>
                        <li>Выполнение требований <strong>KYC</strong>, <strong>KYT</strong> и <strong>Travel Rule</strong>.</li>
                        <li>Информационная и финансовая безопасность клиентов.</li>
                        </ul>
                    </div>

                    <!-- Link -->
                    <div class="d-flex align-items-start" style="gap: 1rem; line-height: 1.25;">
                        <svg width="18" height="18" viewBox="0 0 16 16" fill="#0dcaf0" aria-hidden="true" style="margin-top: .25rem;">
                        <path d="M6.364 13.657L2.707 10l3.657-3.657 1.414 1.414L5.536 10l2.121 2.121-1.293 1.536z"/>
                        <path d="M9 3h5v5h-2V5.414L6.707 10.707l-1.414-1.414L10.586 4H9V3z"/>
                        </svg>
                        <p class="mb-0" style="font-size: 1.05rem;">
                        Проверить действующий статус лицензии можно на сайте регулятора:
                        <a href="https://www.afsa.kz" target="_blank" rel="noopener" class="link-info text-decoration-none fw-semibold">www.afsa.kz</a>
                        </p>
                    </div>
                    </div>

                </b-col>
               
            </b-row>
        </b-col>
       
    </b-row>
</template>

<script>
    
    import axios from 'axios';
    import {mapActions,mapState} from 'vuex';
    export default {
        name: "ContentMore",
        data(){
            return {
                svgWidth: 150,
                svgHeight: 30,
                coinData: [],
                items: [
                    { title: "Как это работает?", content: "Здесь будет текстовое описание", active: false },
                    { title: "Как я могу торговать криптовалютой?", content: "Здесь будет текстовое описание", active: false },
                ]
            }
        },
        methods:{
            changeRoute(routeName){
                this.$router.push('/'+routeName)
            },
            async fetchBitcoinPriceData(ids) {
                const endpoint = 'https://api.coingecko.com/api/v3/coins/markets?x_cg_demo_api_key=CG-UhwnpGqWNHeMipRrQ8Wr5Yxr';
                const params = {
                    vs_currency: 'usd',
                    days: 0, // Fetch 7 days of data
                    interval: 'daily',
                    ids:ids,
                    order: 'market_cap_desc', // Order by market capitalization
                    per_page: 2, // Number of coins per page
                    page: 1, // Page number
                    sparkline: true // Disable sparkline
                };

                try {
                    const response = await axios.get(endpoint, {
                        params: params,
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CoinGecko-Api-Key': 'CG-UhwnpGqWNHeMipRrQ8Wr5Yxr'
                        }
                    });
                    
                    console.log('Bitcoin price data:', response.data);
                    
                
                    // Truncate sparkline_in_7d to include only the last 7 days
                    const coinData = response.data.map(coin => {
                        const sparklineData = coin.sparkline_in_7d.price.slice(-7); // Get the last 7 days
                        return { ...coin, sparkline_in_7d: sparklineData };
                    });

                    
                    this.coinData = this.coinData.concat(coinData);
                    
                } catch (error) {
                    console.error('Error fetching Bitcoin price data:', error);
                }
            },
            generatePath(priceData, index) {
                const dataLength = priceData.length;
                const priceMax = Math.max(...priceData);
                const priceMin = Math.min(...priceData);
                const priceRange = priceMax - priceMin;
                const xStep = this.svgWidth / (dataLength - 1);

                let path = `M0 ${this.svgHeight - ((priceData[0] - priceMin) / priceRange) * this.svgHeight}`;
                for (let i = 1; i < dataLength; i++) {
                    const x = i * xStep;
                    const y = this.svgHeight - ((priceData[i] - priceMin) / priceRange) * this.svgHeight;
                    path += ` L${x} ${y}`;
                }

                return path;
            },
            toggleAccordion(index) {
                this.items[index].active = !this.items[index].active;
            },
            hasRole(roleName){
                if(this.loginedUser && this.loginedUser.userRoles){
                    let roleNames = this.loginedUser.userRoles;
                    if(roleNames.length>0){
                    //alert(JSON.stringify(roleNames));
                    for(let r=0;r<roleNames.length;r++){
                        
                        if(roleNames[r].name===roleName){
                        return true;
                        }
                    }
                    }
                    else{
                    return false;
                    }
                }
                return false;
                
                
            }
        },
        mounted(){
            this.fetchBitcoinPriceData( 'bitcoin,ethereum');
      
            this.fetchBitcoinPriceData( 'tether,binancecoin');
        },
        computed:{
            ...mapState([
                'loginedUser'
            ]),
        }
        
    }   
</script>
<style>
    .copyright{        
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .main-bottom-top{
        height: 1px;
        background: var(--Neutrals-2, #23262F);
    }
    .no-style-input{
        appearance: none;
        background-color: transparent;
        border: none;
        outline: none;
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        line-height: inherit;
        padding: 0;
        margin: 0;
    }
    .sub-container{
        border-radius: 16px;
        border: 2px solid var(--Neutrals-6, #E6E8EC);
    }
    .footer-addr{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .footer-link{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .accordion-item{
        cursor: pointer;
    }
    .accordion-item-answer{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .accordion-item-question{
        cursor: pointer;
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .accordion-item {
        width: 100%;
        max-width: 546px;
        margin: 0 auto;
        border-bottom:1px solid var(--Neutrals-3, #353945);
        
    }
    .service-btn-container{
        cursor: pointer;
        border-radius: 12px;
        background: var(--Primary-1, #EFB914);
    }
    .service-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .service-item-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .service-item-name{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .service-item{
        border-radius: 20px;
        background: var(--Neutrals-1, #141416);
    }
    .service-desc{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .no-style {
        color: inherit; /* Inherit color from parent */
        text-decoration: none; /* Remove underline */
    }
    .news-item-desc{
        
        color: var(--Neutrals-4, #777E90);
        overflow: visible; 
        white-space: normal; 
        text-overflow: clip;
        /* Caption */
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 171.429% */
    }
    .news-item-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
    }
    .main-news-desc{
        overflow: hidden;
        color: var(--Neutrals-4, #777E90);
        text-overflow: ellipsis;
        white-space: pre-wrap;
        height: auto;
        /* Body 2 */
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .main-news-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 40px; /* 125% */
        letter-spacing: -0.96px;
    }
    .trade-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .trade-btn{
        cursor: pointer;
        border-radius: 8px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .list-text-percentage{
        color: var(--Primary-4, #58BD7D);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-price{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; 
    }
    .list-sep{
        height: 1px;
        border-radius: 2px;
        background: var(--Neutrals-3, #353945);
    }
    .list-text-code{
        color: var(--Neutrals-5, #B1B5C3);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-crypto{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-text-number{
        color: var(--Neutrals-4, #777E90);
        text-align: center;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
    .list-header-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .tab-btn:hover{
        cursor: pointer;
        border-radius: 8px;
        background: var(--Neutrals-3, #353945);
    }
    .tab-btn:hover .tab-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
    }
    .tab-btn-text{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
    .more-btn-container{
        cursor: pointer;
        border-radius: 12px;
        border: 2px solid var(--Neutrals-3, #353945);
    }
    .clist-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 56px;
        letter-spacing: -0.96px;
    }
    .main-sep{
        height: 1px;
        background: #B1B5C3;
    }
    .crypto-cost-current{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
    }
    .crypto-cost-prev{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .crypto-percentage{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
        border-radius: 24px;
        background: var(--Primary-3, #FF6838);
    }
    .crypto-name{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
    }
    .crypto-item:hover{
        cursor: pointer;
        border-radius: 16px;
        background: var(--Neutrals-3, #353945);
        box-shadow: 0px 64px 64px -48px rgba(15, 15, 15, 0.10);
    }
    .banner-crypto-container{
        border-radius: 24px;
        background: var(--Neutrals-2, #23262F);
    }
    .banner-title{
        color: var(--Neutrals-8, #FCFCFD);
        font-family: Inter;
        font-size: 64px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        letter-spacing: -1.28px;
    }
    .banner-desc{
        color: var(--Neutrals-4, #777E90);
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    .crypto-btn{
        border-radius: 12px;
        border: 2px solid var(--Neutrals-4, #777E90);
    }
    .crypto-btn-text{
        color: var(--Neutrals-8, #FCFCFD);
        text-align: right;
        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 16px;
    }
</style>

